import React from 'react';
import { useState, useEffect } from 'react';
import { connect, useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Button,
  Card,
  Row,
  Col,
  message,
  Layout,
  Radio,
  Input,
  PageHeader,
  Tooltip,
  Typography,
  Select,
  Switch,
  Steps,
  Modal,
  Tabs,
} from 'antd';
import axios from 'axios';

import queryString from 'query-string';
import {
  CloseOutlined,
  ArrowLeftOutlined,
  EditOutlined,
  SlackOutlined,
} from '@ant-design/icons';
import { getCardTemplates } from '../skill_builder/steps/CardActions';
import AppearancePage from './reportAppearancePage';
import SourceDataOptions from './sourceDataOptions';
import TriggerStep from '../skill_builder/steps/cardInvocationDetails/schedule';
import SlackStep from '../skill_builder/steps/cardInvocationDetails/slackChannel';
import Recipient from '../skill_builder/steps/cardInvocationDetails/recipient';
import IssueCardFieldCustomizationInfo from '../jira/IssueCardCustomization/IssueCardFieldCustomizationInfo';

import { getJiraIssueNodeFields } from '../skill_builder/skillBuilderActions';
import { getProject, getJiraBoards, getFilterFromJira } from '../skills_action';
import {
  saveCardSkills,
  updateCardSkills,
  getCardSkills,
} from '../skill_builder/steps/CardActions';
import {
  resetStore,
  triggerInfo,
  slackInfo,
  accessInfo,
  cardInfo,
  handleIssueCardConfigChanges,
  handleTemplateFormat,
  handleAppearanceData,
  setGraphColors,
  handleSendNotifications,
} from './report_actions';
import SortList from './SortList';
// import { newTemplateData } from './templateData';
import BarChartSvg from './LayoutBlocks/BarChart.svg';
import DarkBarChartSvg from './LayoutBlocks/Report type icons - dark mode/Bar chart.svg';
import LineChart from './LayoutBlocks/Linechart.svg';
import DarkLineChart from './LayoutBlocks/Report type icons - dark mode/Line chart.svg';
import BurnDownChart from './LayoutBlocks/Burndownchart.svg';
import DarkBurnDownChart from './LayoutBlocks/Report type icons - dark mode/Burndown chart.svg';
import listreport from './LayoutBlocks/Listreport.svg';
import Darklistreport from './LayoutBlocks/Report type icons - dark mode/List report.svg';
import PieChart from './LayoutBlocks/Piechart.svg';
import DarkPieChart from './LayoutBlocks/Report type icons - dark mode/Pie chart.svg';
import TextSummary from './LayoutBlocks/Textsummary.svg';
import DarkTextSummary from './LayoutBlocks/Report type icons - dark mode/Text summary.svg';
import VelocityChart from './LayoutBlocks/VelocityChart.svg';
import DarkVelocityChart from './LayoutBlocks/Report type icons - dark mode/Velocity chart.svg';
import TitleModal from './TitleModal';
import ReportAccess from '../skill_builder/steps/cardInvocationDetails/reportAccess';
import jwt from 'jsonwebtoken';

const { Content } = Layout;
const { Text, Title } = Typography;
const { Option } = Select;
const { Step } = Steps;

const CreationPage = (props) => {
  let description = 'Report';
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [key, setKey] = useState('');

  const [basicReportData, setBasicReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [chartType, setChartType] = useState('chart');
  const [current, setCurrent] = useState(0);
  const [showNameChangeModel, setShowNameChangeModel] = useState(false);
  const [buttonDisable, setButtonDisable] = useState(false);
  const [filterFromJira, setFilterFromJira] = useState(null);
  const [reportTheme, setReportTheme] = useState(true);
  const [showCardCustomiztionModal, setShowCardCustomiztionModal] =
    useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [purpose, setPurpose] = useState('');

  const [numberFields, setNumberFields] = useState({});
  const [userFields, setUserFields] = useState([]);

  const [cardSkill, setCardSkill] = useState();
  const [template, setTemplate] = useState();
  const [error, setError] = useState(false);
  const [testRunLoading, setTestRunLoading] = useState(false);

  const [sourceDataTab, setSourceDataTab] = useState('sourceData');
  const [tempCardInfo, setTempCardInfo] = useState({});

  let cardInformation = useSelector((state) => state.report.cardInfo);
  let slackData = props.report.slackData;
  const newTemplateData = useSelector((state) => state.cards.templateCards);

  useEffect(() => {
    if (!newTemplateData.length)
      dispatch(getCardTemplates(props.match.params.wId, `app=Jira`));
  }, []);

  useEffect(() => {
    getIssueNumberFields();
    let query = '';
    let wId = localStorage.getItem('');
    props
      .getJiraIssueNodeFields(props.match.params.wId, query)
      .then((res) => { });

    getFilterFromJira(props.match.params.wId).then((res) => {
      if (res && res.data && res.data.success)
        setFilterFromJira(res.data.items);
    });
    props.getProject(props.match.params.wId).then((res) => { });
  }, []);

  useEffect(() => {
    if (props.cardSkill || props.template) {
      setCardSkill(props.cardSkill);
      setTemplate(props.template);
    } else {
      const parsedQueryString = queryString.parse(props.location.search);
      if (parsedQueryString) {
      }
    }
  }, [props.cardSkill, props.template]);

  useEffect(() => {
    if (cardSkill) {
      props.isEditMode && handleCardSkillData(cardSkill, cardInformation, null);
    } else {
      handleCardSkillData(null, cardInformation, template);
    }
  }, [template]);

  const handleCardSkillData = (cardSkill, cardInformation, template) => {
    // console.log('handlecardSkillData', cardInformation, cardSkill, template);
    if (cardSkill && cardInformation) {
      // console.log('creation page =>card information');
      setLoading(false);
      if (cardInformation.send_as && cardInformation.send_as == 'summary') {
        setBasicReportData({
          name: cardSkill.name,
          reportType: 'summary',
        });
        setReportTheme(cardInformation.report_theme == 'dark' ? true : false);
      } else {
        setBasicReportData({
          name: cardSkill.name,
          reportType: cardInformation.report_type,
        });

        setReportTheme(cardInformation.report_theme == 'dark' ? true : false);
      }
      props.cardInfo({ ...props.report.cardInfo, ...cardInformation });
      setPurpose(cardSkill.desc);
    } else if (template) {
      // console.log('creation template', template.defaultValues);
      setLoading(false);
      setBasicReportData({
        name: template.name,
        reportType:
          basicReportData && basicReportData.reportType
            ? basicReportData.reportType
            : template.defaultValues && template.defaultValues.report_type,
      });
      setReportTheme(
        (template.defaultValues && template.defaultValues.report_theme) ===
          'dark'
          ? true
          : false
      );
      props.cardInfo({
        ...props.report.cardInfo,
        ...(template.defaultValues ? template.defaultValues : {}),
      });
      template.desc && setPurpose(template.desc);
    }

    if (cardSkill && cardSkill.triggerInformation) {
      props.triggerInfo(cardSkill.triggerInformation);
    }
    if (cardSkill && cardSkill.slackData) {
      props.slackInfo(cardSkill.slackData);
    }

    if (cardSkill && cardSkill.reportAccessMembers) {
      props.accessInfo(cardSkill.reportAccessMembers);
    }

    if (cardSkill) {
      props.handleSendNotifications(cardSkill.sendNotificationMessage);
    }
    if (
      cardSkill &&
      cardSkill.cardInformation &&
      cardSkill.cardInformation.issueCardCustomizationInfo &&
      Object.keys(cardSkill.cardInformation.issueCardCustomizationInfo).length >
      0
    ) {
      props.handleIssueCardConfigChanges(
        cardSkill.cardInformation.issueCardCustomizationInfo
      );
    } else {
      let defaultIssueCardCustomizationInfo = {
        showDescription: false,
        fieldsSelectedDetailed: [],
        fieldSelectedCompact: {
          name: 'status',
          key: 'status',
        },
        buttonActions: [
          {
            name: 'View',
            value: 'jira_view_modal',
          },
        ],
        truncateSummary: true,
        showAllDropdownActions: false,
        notificationDisplayFormat: 'standard',
        notificationCollapseMessage: false,
        notificationShowFullIssueCard: true,
        showFooterMessage: true,
        showAtMentionReporter: true,
        showLinktoWebAppConfig: true,
        attributesAllignment: 'vertical',
      };

      props.handleIssueCardConfigChanges(defaultIssueCardCustomizationInfo);
    }

    if (
      cardSkill &&
      cardSkill.cardInformation &&
      cardSkill.cardInformation.cardInformation &&
      cardSkill.cardInformation.cardInformation.appearanceData
    ) {
      props.handleAppearanceData(
        cardSkill.cardInformation.cardInformation.appearanceData
      );
      props.setGraphColors(
        cardSkill.cardInformation.cardInformation.appearanceData
      );

      // console.log('comming to this appearance block');
    }
  };

  const handleStepChange = (val) => {
    if (
      basicReportData &&
      basicReportData.name &&
      basicReportData.name.toString().length > 0
    ) {
      setCurrent(val);
      setTempCardInfo({});
    } else {
      return message.warning('Report title cannot be empty');
    }
  };

  const handleChartType = (val) => {
    setChartType(val);
  };

  const handleChangeName = (val) => {
    setShowNameChangeModel(val);
  };

  const handleCreateReport = async () => {
    if (
      (!(slackData && slackData.slackChannel) ||
        (slackData &&
          slackData.slackChannel &&
          slackData.slackChannel.length == 0)) &&
      (!(slackData && slackData.reportMembers) ||
        (slackData &&
          slackData.reportMembers &&
          slackData.reportMembers.length == 0)) &&
      props.skill_type == 'app_message'
    )
      return message.warning('Please fill all the required fields');

    props.report.cardInfo.report_type =
      basicReportData && basicReportData.reportType;
    // props.report.cardInfo.report_name = basicReportData && basicReportData.name;
    props.report.cardInfo.report_theme = props.report.cardInfo.report_theme;
    props.report.cardInfo.appearanceData = props.report.appearanceData;

    if (
      props.report.slackData &&
      props.report.slackData.reportMembers &&
      props.report.slackData.reportMembers.length
    ) {
      props.report.slackData.reportMembers =
        props.report.slackData.reportMembers.map((member) => {
          const selectedMember =
            props.membersList &&
            props.membersList.find(
              (memb) =>
                memb.user_id === member ||
                memb.slackInfo.user_name === member ||
                memb.slackInfo.displayName === member
            );
          if (selectedMember && selectedMember.slackInfo)
            return selectedMember.user_id;
          else return member;
        });
    }

    if (
      props.report.reportAccessMembers &&
      props.report.reportAccessMembers.length
    ) {
      props.report.reportAccessMembers = props.report.reportAccessMembers.map(
        (member) => {
          const selectedMember =
            props.membersList &&
            props.membersList.find(
              (memb) =>
                memb.user_id === member ||
                memb.slackInfo.user_name === member ||
                memb.slackInfo.displayName === member
            );
          if (selectedMember && selectedMember.slackInfo)
            return selectedMember.user_id;
          else return member;
        }
      );
    }

    let data = {
      cardInformation: {
        cardInformation: props.report.cardInfo,
        card_template_id: props.report.card_template_id._id,
        key: props.report.card_template_id.key,
        issueCardCustomizationInfo: props.report.issueCardInfo,
      },

      slackData: props.report.slackData,
      triggerInformation: props.report.triggerInformation,
      sendNotificationMessage: props.report.sendNotificationMessage,
      reportAccessMembers: props.report.reportAccessMembers,
    };

    data.workspace_id = props.match.params.wId;
    data.app = props.report.card_template_id.app;
    //  this.props.cardSkill.app=="Jira"
    data.name = basicReportData && basicReportData.name;
    data.desc = purpose;
    data.skill_type = props.skill_type;

    if (props.report.isEditMode) {
      data.cardInformation._id =
        props &&
        props.report &&
        props.report.template &&
        props.report.template.cardInformation._id;

      data._id = props.report.template._id;

      data.name = basicReportData && basicReportData.name;

      data.desc = purpose;

      if (
        props.report.card_template_id &&
        props.report.card_template_id.key === 'custom_report_2'
      ) {
        data.name = basicReportData.name;
      }

      const res = await props.updateCardSkills(props.match.params.wId, data)
      if (res.data.success) {
        const res2 = await props
          .getCardSkills(props.match.params.wId, props && props.skill_type)

        message.success('Your report has been updated successfully');
        props.setShowCreationPage(false);
        props.setCurrent('my_reports');
        props.resetStore();
        setBasicReportData(null);
      } else if (res.data.success === false && res.data.message) {
        message.error(res.data.message || "Error updating report");
      } else {
        message.error('Error updating report');
      }

    } else {
      const res = await props.saveCardSkills(props.match.params.wId, data)
      if (res.data.success) {
        // props
        //   .getCardSkills(props.match.params.wId, props.skill_type)
        //   .then((res) => {
        message.success('Your report has been created successfully');
        props.setShowCreationPage(false);
        props.setCurrent('my_reports');
        props.resetStore();
        setBasicReportData(null);
        // });
      } else if (res.data.success === false && res.data.message) {
        message.error(res.data.message || "Error creating report");
      } else {
        message.error('Error creating report');
      }



      // console.log('FINAL DATA', data, props);
    };
  }
  const setExistingDataOnTypeChange = (
    e,
    existingData,
    existingKey,
    chartType
  ) => {
    if (e.target.value == 'summary') {
      setBasicReportData({
        ...basicReportData,
        send_as: e.target.value,
        reportType: e.target.value,
      });
    } else {
      setBasicReportData({
        ...basicReportData,
        reportType: e.target.value,
      });
    }
    if (chartType) setChartType(chartType);

    props.cardInfo({
      ...existingData,
      ...props.report.cardInfo,
      ...tempCardInfo,
      send_as: e.target.value,
      report_type: e.target.value,
    });

    let res = newTemplateData.find((t) => t.key === existingKey);
    props.handleTemplateFormat(res);
    setTemplate(res);
    setKey(existingKey);
  };

  const setTemplateDataOnTypeChange = (e, key, chartType, cardSkill) => {
    // console.log('new data', props.report.cardInfo);
    if (e.target.value == 'summary') {
      setBasicReportData({
        ...basicReportData,
        send_as: e.target.value,
        reportType: e.target.value,
      });
    } else {
      setBasicReportData({
        ...basicReportData,
        reportType: e.target.value,
      });
    }
    if (chartType) setChartType(chartType);
    if (cardSkill) setCardSkill(cardSkill);
    let res = newTemplateData.find((t) => t.key === key);
    props.handleTemplateFormat(res);
    setTemplate(res);
    // console.log('hello here we are changing the reportType', key, res.key,props.report.cardInfo)
    if (res.key == 'jira_count_graph' || res.key == 'custom_report_2') {
      props.cardInfo({
        ...res.defaultValues,
        ...props.report.cardInfo,
        send_as: e.target.value,
        report_type: e.target.value,
        template_key: res.key,
        ...(res.key == 'custom_report_2' && { report_name: 'Custom Report' }),
      });
    } else {
      if (tempCardInfo && Object.keys(tempCardInfo) > 0);
      else setTempCardInfo(props.report.cardInfo);
      props.cardInfo({
        ...res.defaultValues,
        ...props.report.cardInfo,
        send_as: e.target.value,
        report_type: e.target.value,
      });
    }
    setKey(key);
  };

  const onOkforTitleModal = (data) => {
    setBasicReportData({
      ...basicReportData,
      name: data.name,
    });
    setPurpose(data.purpose);
    setShowNameChangeModel(false);
  };

  const handleReportTypeChange = (e) => {
    let existingData =
      cardSkill &&
      cardSkill.cardInformation &&
      cardSkill.cardInformation.cardInformation;

    let existingKey =
      cardSkill && cardSkill.cardInformation && cardSkill.cardInformation.key;

    if (e.target.value === 'list') {
      setChartType('list');
      setBasicReportData({
        ...basicReportData,
        reportType: e.target.value,
      });
      let res = newTemplateData.find((t) => t.name === 'Issues by Custom JQL');
      props.handleTemplateFormat(res);
      setTemplate(res);
      const cardInfo = { ...props.report.cardInfo, ...res.defaultValues };
      delete cardInfo.send_as;
      props.cardInfo(cardInfo);
      setKey('get_issues_by_jql');
    } else if (e.target.value === 'velocity') {
      if (existingKey === 'jira_velocity_chart') {
        setExistingDataOnTypeChange(e, existingData, existingKey, 'chart');
      } else {
        setTemplateDataOnTypeChange(e, 'jira_velocity_chart', 'chart');
      }
    } else if (e.target.value === 'burn') {
      if (existingKey === 'jira_burn_down_chart') {
        setExistingDataOnTypeChange(e, existingData, existingKey, 'chart');
      } else {
        setTemplateDataOnTypeChange(e, 'jira_burn_down_chart', 'chart');
      }
    } else {
      if (
        existingKey === 'custom_report_2' ||
        existingKey === 'jira_count_graph'
      ) {
        setExistingDataOnTypeChange(e, existingData, existingKey, 'chart');
      } else {
        setTemplateDataOnTypeChange(e, 'custom_report_2', 'chart');
      }
    }
  };
  const handleTestRun = async () => {
    if (
      (!(slackData && slackData.slackChannel) ||
        (slackData &&
          slackData.slackChannel &&
          slackData.slackChannel.length == 0)) &&
      (!(slackData && slackData.reportMembers) ||
        (slackData &&
          slackData.reportMembers &&
          slackData.reportMembers.length == 0))
    )
      return message.warning('Please fill all the required fields');
    // console.log(props.report, basicReportData);
    setTestRunLoading(true);
    props.report.cardInfo.report_type =
      basicReportData && basicReportData.reportType;
    // props.report.cardInfo.report_name = basicReportData && basicReportData.name;
    props.report.cardInfo.report_theme = props.report.cardInfo.report_theme;
    props.report.cardInfo.appearanceData = props.report.appearanceData;

    let data = {
      cardInformation: {
        cardInformation: props.report.cardInfo,
        card_template_id: props.report.card_template_id._id,
        key: props.report.card_template_id.key,
        issueCardCustomizationInfo: props.report.issueCardInfo,
      },

      slackData: { ...props.report.slackData },
      triggerInformation: { ...props.report.triggerInformation },
    };

    data.workspace_id = props.match.params.wId;
    data.app = props.report.card_template_id.app;
    //  this.props.cardSkill.app=="Jira"
    data.name = basicReportData && basicReportData.name;
    data.desc = purpose;
    data.skill_type = props.skill_type;

    if (props.report.isEditMode) {
      data.cardInformation._id =
        props &&
        props.report &&
        props.report.template &&
        props.report.template.cardInformation._id;

      data._id = props.report.template._id;

      data.name = basicReportData && basicReportData.name;

      data.desc = purpose;

      if (
        props.report.card_template_id &&
        props.report.card_template_id.key === 'custom_report_2'
      ) {
        data.name = basicReportData.name;
      }
    }
    // console.log(props);
    data.user_id = props.user_now._id;
    data.workspace_id = props.match.params.wId;
    // console.log('FINAL TEST DATA', data);

    axios
      .post(`/bot/api/w/${props.match.params.wId}/reports/testCardSkill`, data)
      .then((res) => {
        // console.log(res);
        if (res && res.data && res.data.success) {
          setTestRunLoading(false);
          message.success(res.data.message);
          // 'Test report sent successfully in Slack');
        } else {
          setTestRunLoading(false);
          message.error(res && res.data && res.data.message);
        }
      })
      .catch((err) => {
        setTestRunLoading(false);
        message.error('Test run failed');
      });
  };

  const getReporTypeField = () => {
    const webAppTheme = localStorage.getItem('theme');
    return (
      <Radio.Group
        value={
          (basicReportData && basicReportData.reportType) ||
          (cardInformation && cardInformation.report_type)
        }
        onChange={(e) => handleReportTypeChange(e)}
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          minHeight: '32px',
        }}
      >
        {' '}
        <Tooltip title='Bar chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='column'
          >
            <img
              src={webAppTheme === 'dark' ? DarkBarChartSvg : BarChartSvg}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title='Line chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='line'
          >
            <img
              src={webAppTheme === 'dark' ? DarkLineChart : LineChart}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title='Pie chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='pie'
          >
            <img
              src={webAppTheme === 'dark' ? DarkPieChart : PieChart}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        {props.skill_type == 'app_message' && (
          <Tooltip title='Summary text'>
            <Radio.Button
              style={{
                padding: '2px 12px 6px 12px',
                display: 'flex',
                alignItems: 'center',
              }}
              value='summary'
            >
              {/* <FileTextOutlined /> */}
              <img
                src={webAppTheme === 'dark' ? DarkTextSummary : TextSummary}
                alt='Chart'
              />
            </Radio.Button>
          </Tooltip>
        )}
        <Tooltip title='Burndown chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='burn'
          >
            <img
              src={webAppTheme === 'dark' ? DarkBurnDownChart : BurnDownChart}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        <Tooltip title='Velocity Chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='velocity'
          >
            <img
              src={webAppTheme === 'dark' ? DarkVelocityChart : VelocityChart}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        {/* {props.skill_type == 'app_message' && ( */}
        <Tooltip title='List Chart'>
          <Radio.Button
            style={{
              padding: '2px 12px 6px 12px',
              display: 'flex',
              alignItems: 'center',
            }}
            value='list'
          >
            <img
              src={webAppTheme === 'dark' ? Darklistreport : listreport}
              alt='Chart'
            />
          </Radio.Button>
        </Tooltip>
        {/* )} */}
      </Radio.Group>
    );
  };

  const getIssueNumberFields = () => {
    return axios
      .get(
        `/bot/api/w/${props.match.params.wId}/skill/${props.match.params.skill_id}/getAllFields/user/${props.currentSkillUser.user_id}`,
        {
          params: {},
        }
      )
      .then((res) => {
        // console.log('issue number fields ', res);
        // console.log(JSON.stringify(res.data.items.projects[0].issuetypes[0].fields))
        if (res.data.success) {
          let values = Object.values(res.data.items);
          let numberFields = values.filter(
            (field) => field.schema && field.schema.type === 'number'
          );
          let userFields = values.filter(
            (field) =>
              (field.schema && field.schema.type === 'user') ||
              (field.schema &&
                field.schema.type === 'array' &&
                field.schema.items === 'user')
          );
          setNumberFields(numberFields);
          setUserFields(userFields);
        }
      })
      .catch((e) => console.error(e));
  };

  const handleIssueCardConfigChanges = (data) => {
    // console.log(data);

    props.handleIssueCardConfigChanges(data);
    setShowCardCustomiztionModal(false);
  };

  const tabList = [
    {
      key: 'sourceData',
      tab: 'Source Data',
    },
    {
      key: 'displayOptions',
      tab: 'Display Options',
    },
  ];

  return (
    <Layout>
      {showNameChangeModel && (
        <TitleModal
          showNameChangeModel={showNameChangeModel}
          basicReportData={basicReportData}
          setBasicReportData={(data) => {
            setBasicReportData(data);
          }}
          onOkforTitleModal={onOkforTitleModal}
          purpose={purpose}
          handleChangeName={handleChangeName}
        />
      )}

      {showCardCustomiztionModal && (
        <IssueCardFieldCustomizationInfo
          close={() => {
            setShowCardCustomiztionModal(false);
          }}
          // handleapphomeCardCustomization={updateapphomeCustomizationInfo}
          // apphomeCardCustomization={apphomeCardCustomization}
          handleReportCardCustomization={handleIssueCardConfigChanges}
          // apphome={apphome}
          customizationIn='report'
          chartType={chartType}
          open={showCardCustomiztionModal}
        />
      )}

      <PageHeader
        title={
          <div>
            {/* <Button
              onClick={() => {
                props.setShowCreationPage(false);
                // props.setCurrent('my_reports');
                setBasicReportData(null);
                props.resetStore();
              }}> */}
            <ArrowLeftOutlined
              style={{
                color:
                  localStorage.getItem('theme') == 'default'
                    ? 'rgba(0, 0, 0, 0.45)'
                    : 'grey',
                marginRight: 16,
              }}
              onClick={() => {
                if (current == 1) {
                  handleStepChange(0);
                } else {
                  props.setShowCreationPage(false);
                  props.setIsEditMode(false);
                  // props.setCurrent('my_reports');
                  setBasicReportData(null);
                  props.resetStore();
                }
              }}
            />
            {/* </Button> */}
            {'   '}
            {props.report && props.report.isEditMode
              ? props.report.template.name
              : `Add Report`}
          </div>
        }
        extra={
          // <Button
          //   icon={<CloseOutlined />}
          //   onClick={() => {
          //     props.setShowCreationPage(false);
          //     props.setCurrent('my_reports');
          //     setBasicReportData(null);
          //     props.resetStore();
          //   }}></Button>
          <CloseOutlined
            style={{
              color:
                localStorage.getItem('theme') == 'default'
                  ? 'rgba(0, 0, 0, 0.45)'
                  : 'grey',
            }}
            onClick={() => {
              props.setShowCreationPage(false);
              props.setCurrent('my_reports');
              setBasicReportData(null);
              props.resetStore();
              // console.log(props)
              props.setIsEditMode(false);
            }}
          />
        }
        style={{
          backgroundColor:
            localStorage.getItem('theme') == 'default' ? 'white' : 'black',
          // marginLeft: '32px',
          // marginRight: '32px',
          marginBottom: 32,
        }}
      >
        {/* <Card
          style={{
            width: '100%',
            marginBottom: 8,
          }}> */}

        {props.skillView && props.skillView.view !== 'appHome' && (
          <div style={{ paddingLeft: 250, paddingRight: 200 }}>
            <Steps current={current}>
              <Step title='Setup The Report'>{description}</Step>
              <Step title='Schedule and Share' /* subTitle='Left 00:00:08' */>
                {description}
              </Step>
            </Steps>
          </div>
        )}
        {/* </Card> */}
      </PageHeader>

      <Content
        style={{
          marginLeft: 32,
          marginRight: 32,
          marginBottom: 32,
        }}
      >
        <Row gutter={[16, 0]}>
          <Col span={12}>
            {current == 1 ? (
              <>
                <Row gutter={[0, 16]}>
                  <Card title='Schedule' style={{ width: '100%' }}>
                    <TriggerStep
                      mode={props.mode ? props.mode : 'save'}
                      data={data}
                      nextStep={(data) => props.triggerInfo(data)}
                      // prevStep={() => this.onStepChange('configure_step')}
                      skill_type='app_message'
                    />
                  </Card>

                  <Card title='Recipient' style={{ width: '100%' }}>
                    <Recipient
                      /* reportMembers={this.props.reportMembers} */ selectMode={`multiple`}
                      data={cardSkill}
                      skill_type='app_message'
                      setError={(data) => setError(data)}
                      membersList={props.membersList}
                    />
                  </Card>
                  <Card
                    title='Report Admins'
                    style={{
                      width: '100%',
                    }}
                  >
                    <ReportAccess membersList={props.membersList} />
                  </Card>
                </Row>

                <Button
                  style={{ marginTop: 16 }}
                  onClick={() => {
                    handleStepChange(0);
                  }}
                >
                  Back
                </Button>
              </>
            ) : (
              <Row gutter={[0, 16]}>
                <Card title='Title and Type' style={{ width: '100%' }}>
                  <div
                    style={{
                      display: 'flex',
                      marginBottom: 24,
                      alignItems: 'center',
                    }}
                  >
                    <Text
                      strong
                      style={{
                        minWidth: '100px',
                        float: 'right',
                      }}
                    >
                      Title
                    </Text>
                    <Text style={{ marginRight: 16 }}>
                      {basicReportData && basicReportData.name}
                    </Text>
                    <Button
                      icon={<EditOutlined />}
                      onClick={() => handleChangeName(true)}
                    >
                      Edit
                    </Button>
                  </div>
                  {/* <div style={{ display: 'flex', marginBottom: 24 }}>
                    <Text
                      style={{
                        minWidth: '100px',
                        float: 'right',
                      }}>
                      Purpose
                    </Text>
                    <Text style={{ marginRight: 16 }}>{purpose}</Text>
                    
                  </div> */}
                  {
                    <div style={{ display: 'flex' }}>
                      <div style={{ minWidth: '100px', alignItems: 'center' }}>
                        <Text strong>Report Type </Text>
                      </div>
                      {getReporTypeField()}
                    </div>
                  }
                </Card>

                {template &&
                  ((basicReportData &&
                    basicReportData.reportType === 'column') ||
                    (basicReportData &&
                      basicReportData.reportType === 'line') /* ||
                    (basicReportData &&
                      basicReportData.reportType === 'pie')  */ ? (
                      <>
                        <Card
                        /* title={<p style={{fontSize:12}}>Source Data And Options</p>} */ style={{
                            width: '100%',
                          }}
                          activeTabKey={sourceDataTab}
                          onTabChange={(value) => {
                            setSourceDataTab(value);
                          }}
                        >
                          <Tabs style={{ overflow: 'visible' }}>
                            <Tabs.TabPane tab='Source Data' key='sourceData'>
                              <SourceDataOptions
                                card_template_id={template}
                                cardInformation={cardInformation}
                                chartType={chartType}
                                reportType={
                                  basicReportData && basicReportData.reportType
                                }
                                handleChartType={(data) => handleChartType(data)}
                                filterFromJira={filterFromJira}
                                numberFields={numberFields}
                                skill_type={props.skill_type}
                              />
                            </Tabs.TabPane>
                            <Tabs.TabPane
                              tab='Display Options'
                              key='displayOptions'
                            >
                              <SortList />
                            </Tabs.TabPane>
                          </Tabs>
                        </Card>
                      </>
                    ) : (
                      template && (
                        <Card
                          title='Source Data And Options'
                          style={{ width: '100%' }}
                        >
                          <SourceDataOptions
                            card_template_id={template}
                            cardInformation={cardInformation}
                            chartType={chartType}
                            reportType={
                              basicReportData && basicReportData.reportType
                            }
                            handleChartType={(data) => handleChartType(data)}
                            filterFromJira={filterFromJira}
                            numberFields={numberFields}
                            skill_type={props.skill_type}
                          />
                        </Card>
                      )
                    ))}
              </Row>
            )}
          </Col>

          <Col span={12}>
            <Card
              title='Appearance'
              extra={[
                <div key='dark theme'>
                  {basicReportData &&
                    basicReportData.reportType &&
                    !(
                      basicReportData.reportType == 'list' ||
                      basicReportData.reportType == 'summary'
                    ) && (
                      <>
                        {' '}
                        <Text>Dark Theme </Text>
                        <Switch
                          checked={reportTheme}
                          onChange={(e) => {
                            // console.log('event ', e);
                            setReportTheme(e);
                            let data = props.report && props.report.cardInfo;
                            props.cardInfo({
                              ...data,
                              report_theme: e ? 'dark' : 'default',
                            });
                          }}
                          // loading={
                          //   props.report &&
                          //   props.report.cardInfo &&
                          //   props.report.cardInfo.hasOwnProperty('report_theme')
                          //     ? false
                          //     : true
                          // }
                          style={{ marginLeft: 8 }}
                          key='theme_switch'
                          label='Dark theme'
                        ></Switch>
                      </>
                    )}
                </div>,
              ]}
            >
              <AppearancePage
                type={chartType}
                basicReportData={basicReportData}
                reportType={basicReportData && basicReportData.reportType}
                changeStep={handleStepChange}
                current={current}
                skill_type={props.skill_type}
                userFields={userFields}
                showCardCustomiztionModal={showCardCustomiztionModal}
                showCustomizeModal={(val) => setShowCardCustomiztionModal(val)}
                template={template}
                handleCreateReport={handleCreateReport}
                isEditMode={props.isEditMode}
              />
            </Card>

            {current == 1 && (
              <div
                style={{
                  marginTop: 16,
                  display: 'flex',
                  justifyContent: 'right',
                  columnGap: 8,
                }}
              >
                <Button
                  onClick={() => {
                    handleTestRun();
                  }}
                  icon={<SlackOutlined />}
                  loading={testRunLoading}
                >
                  Test run in Slack
                </Button>
                <Button
                  type='primary'
                  onClick={() => {
                    handleCreateReport();
                  }}
                >
                  {props.report.isEditMode ? 'Update Report' : 'Create Report'}
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

// export default ;

const mapStateToProps = (state) => {
  // console.log(state);
  return {
    projects: state.skills.projects,
    fields: state.skill_builder.fields,
    boards: state.skills.jiraBoards,
    currentSkill: state.skills.currentSkill,
    currentSkillUser: state.skills.currentSkillUser,
    cardSkills: state.cards.cardSkills,
    cardTemplates: state.cards.templateCards,
    channels: state.skills.channels,
    report: state.report,
    user_now: state.common_reducer.user,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getProject,
    getCardSkills,
    getJiraIssueNodeFields,
    saveCardSkills,
    updateCardSkills,
    getJiraBoards,
    getFilterFromJira,
    resetStore,
    triggerInfo,
    slackInfo,
    accessInfo,
    handleSendNotifications,
    cardInfo,
    handleIssueCardConfigChanges,
    handleTemplateFormat,
    handleAppearanceData,
    setGraphColors,
  })(CreationPage)
);
